import config from '../config';

// import sharedContext from '../sharedContext';

let _refreshTm = null;

export const AuthProvider = {
    login: (loginInfo) => {
        // window.shctx = sharedContext;
        const options = {
            method: 'POST',
            cache: 'nocache',
            headers: {
                ContentType: 'application/json',
            },
            body: JSON.stringify({
                username: loginInfo.username,
                password: loginInfo.password,
                host: config.domainOverride || window.location.host,
            }),
        };
        const authUrl = `${config.apiUrl}/login/`;
        const bootstrapUrl = `${config.apiUrl}/bootstrap/`;
        return fetch(authUrl, options).then((res) => {
            if (res.status === 200 || res.status === 201) {
                return res.json().then((data) => {
                    return fetch(bootstrapUrl, {
                        cache: 'nocache',
                        headers: {
                            Authorization: `Token ${data.token}`,
                        },
                    }).then((res) => {
                        return res.json().then((bsdata) => {
                            return Promise.resolve({
                                user: data.user,
                                tour_operator: data.tour_operator,
                                settings: data.settings,
                                token: data.token,
                                token_expires: data.token_expires,
                                countries: bsdata.countries,
                                currencies: bsdata.currencies,
                                roles: bsdata.roles,
                                timeline_types: bsdata.timeline_types,
                            });
                        });
                    });
                });
            } else {
                return Promise.reject();
            }
        });
    },
    logout: () => {
        if (_refreshTm) {
            clearTimeout(_refreshTm);
        }
        // sharedContext.clear();
        return Promise.resolve();
    },
    // checkError: (status) => {
    //     if (status.status === 401 || status.status === 403) {
    //         AuthProvider.logout();
    //         return Promise.reject();
    //     }
    //     return Promise.resolve();
    // },
    checkAuth: () => {
        throw new Error('checkAuth is obsolete and should not be used');
        // try {
        //     const user = sharedContext.get('user');
        //     if (!user) { return false; }
        //     const token = sharedContext.get('token');
        //     // if (!_refreshTm) {
        //     //     AuthProvider.setupNextTokenRotation(null, 1000);
        //     // }
        //     const is_authenticated = !!(token && user && user.id);
        //     console.log('AuthProvider.checkAuth: is_authenticated =', is_authenticated);
        //     return is_authenticated; // ? Promise.resolve() : Promise.reject();
        // } catch(e) {
        //     console.error('AuthProvider.checkAuth.catch', e);
        //     return false; // Promise.reject();
        // }
    },
    // getPermissions: () => Promise.resolve(),

    // setupNextTokenRotation: (data, delay = null) => {
    //     const now = moment()
    //     if (data) {
    //         sharedContext.set('token', data.token);
    //     }
    //     // console.log(`setupNextTokenRotation: delay=${delay}`);
    //     if (data && !delay) {
    //         const exp = moment(data.token_expires);
    //         const refreshTime = exp.subtract(90, "seconds");
    //         delay = refreshTime.diff(now);
    //     }
    //     if (!delay || delay <= 0) { delay = 30000 };
    //     // console.log(`setupNextTokenRotation: now=${now.format()} | refresh in ${delay/1000}s`);
    //     _refreshTm = setTimeout(() => (
    //             AuthProvider.rotateToken()
    //                 .catch((err) => {
    //                     console.warn(`refreshToken: no token found, giving up (error=${err})`);
    //                 })
    //         ), delay);
    // },
    rotateToken: (token) => {
        if (!token) {
            return Promise.reject();
        }
        const options = {
            method: 'POST',
            cache: 'nocache',
            headers: { Authorization: `Token ${token}` },
        };
        const url = `${config.apiUrl}/token/rotate/`;
        return fetch(url, options).then((res, a, b, c) => {
            if ([200, 201].indexOf(res.status) >= 0) {
                return res
                    .json()
                    .then((data) => {
                        return Promise.resolve(data);
                    })
                    .catch((err) => {
                        console.error(`rotateToken: error parsing server response: ${err}`);
                        return Promise.reject(err);
                    });
            } else {
                console.error(`rotateToken: current token is invalid or expired`);
                return Promise.reject(new Error(`${res.status} ${res.statusText}`));
            }
        });
    },
};

export default AuthProvider;
